<p-contextMenu #contextMenu [model]="contextMenuItems"></p-contextMenu>
<div
  #header
  class="flex lg:flex-nowrap justify-between items-start gap-2 pb-2.5 pt-2.5 md:pb-7 relative px-4"
  [ngClass]="{
    'flex-wrap-reverse': config.header?.newButton || config.header?.actions,
  }"
>
  <p-progressBar
    [ngClass]="{
      'absolute top-0 left-0 right-0': true,
      'opacity-0': !loading.isLoading(),
    }"
    [style]="{
      height: '4px',
    }"
    mode="indeterminate"
  />
  <div class="w-full md:w-auto flex flex-nowrap items-center gap-2">
    @if (calendarSelectionMode !== 'none') {
    <p-treeSelect
      [options]="selectCalendarItems()"
      [(ngModel)]="selectedCalendar"
      class="grow md:grow-0 w-full"
      [filter]="true"
      pTooltip="Hlavný kalendár"
    >
      <ng-template #footer>
        <div class="font-medium size-small p-3 min-w-60 bg-primary-50">
          Do tohoto kalendára bude priradená úloha z bočného panelu.
        </div>
      </ng-template>
    </p-treeSelect>
    } @if (calendarSelectionMode !== 'none') {
    <p-treeSelect
      [(ngModel)]="selectedCalendars"
      [options]="selectMoreCalendarItems()"
      display="comma"
      selectionMode="checkbox"
      placeholder="Kalendáre"
      [filter]="true"
      pTooltip="Doplnkové kalendáre"
    >
      <ng-template pTemplate="value">
        @if(selectedCalendars.length > 1) {
        <span>+{{ selectedCalendars.length }}</span>
        } @else {
        <span>{{ selectedCalendars[0]?.label }}</span>
        }
      </ng-template>
      <ng-template #footer>
        <div class="font-medium size-small p-3 min-w-60 bg-primary-50">
          Zobrazi ulohy z viacerých kalendárov naraz.
        </div>
      </ng-template>
    </p-treeSelect>
    }
    <p-button
      [rounded]="true"
      class="sm:hidden"
      pTooltip="Zobraziť nenaplánované úlohy"
      tooltipPosition="left"
      [text]="true"
      size="small"
      [icon]="'pi pi-calendar-clock'"
      (click)="toggleUnscheduled()"
    />
  </div>

  <div
    class="w-full md:w-auto md:ml-auto flex items-center gap-y-2 md:gap-2 justify-end flex-wrap"
  >
    <h2 class="order-4 md:order-none w-1/2 md:w-auto">
      {{ this.calendar?.getApi()?.view?.title }}
    </h2>
    <div
      class="order-5 md:order-none w-1/2 md:w-auto flex items-center justify-end"
    >
      <!-- <p-buttonGroup> -->
      <p-button
        icon="pi pi-chevron-left"
        [text]="true"
        size="small"
        (onClick)="this.calendar?.getApi()?.prev()"
      />
      <p-button
        icon="pi pi-calendar"
        [text]="true"
        size="small"
        (onClick)="this.calendar?.getApi()?.today()"
        pTooltip="Prejsť na dnešný deň"
        tooltipPosition="left"
      />
      <p-button
        icon="pi pi-chevron-right"
        [text]="true"
        size="small"
        (onClick)="this.calendar?.getApi()?.next()"
      />
      <!-- </p-buttonGroup> -->
    </div>

    <div class="order-1 md:order-none w-1/2 md:w-auto">
      @if (config.header?.newButton; as btnConfig) { @if
      (config.header?.actions; as actions) {
      <p-splitButton
        #splitButton
        [label]="btnConfig.label"
        [icon]="btnConfig.icon ?? ''"
        (onClick)="handleHeaderButtonClick($event)"
        [model]="config.header?.actions ?? []"
        [text]="btnConfig.text"
        [outlined]="btnConfig.outlined"
        [rounded]="btnConfig.rounded"
        [severity]="btnConfig.severity"
        [disabled]="btnConfig.disabled"
        [size]="btnConfig.size"
      >
      </p-splitButton>
      } @else {
      <p-button
        [label]="btnConfig.label"
        [routerLink]="btnConfig.routerLink"
        (click)="btnConfig.command?.()"
        [icon]="btnConfig.icon ?? ''"
        type="button"
        [size]="btnConfig.size ?? 'small'"
        [text]="btnConfig.text"
        [outlined]="btnConfig.outlined"
        [rounded]="btnConfig.rounded"
        [severity]="btnConfig.severity"
        [disabled]="btnConfig.disabled"
        [size]="btnConfig.size"
        [loading]="btnConfig.loading"
      ></p-button>
      } } @if (!config.header?.newButton) { @if (config.header?.actions; as
      actions) {
      <p-button
        type="button"
        icon="pi pi-ellipsis-v"
        size="small"
        (click)="actionsMenu.toggle($event)"
      ></p-button>
      } }
    </div>

    <div
      class="w-1/2 md:w-auto ml-auto md:ml-0 flex items-center justify-end gap-2 order-2 md:order-none"
    >
      @if (config.header?.quickActions) { @for ( action of
      config.header?.quickActions; track action.label || action.icon ) {
      <button
        pButton
        type="button"
        [icon]="action.icon ?? ''"
        [label]="action.label ?? ''"
        [routerLink]="action.routerLink"
        [queryParams]="action.queryParams"
        [severity]="action['severity'] ?? 'primary'"
        [disabled]="action.disabled"
        [pTooltip]="action.tooltip ?? action.label"
        [tooltipPosition]="action.tooltipPosition ?? 'left'"
        class="p-button-sm p-button-text"
        [ngClass]="action.styleClass ?? ''"
        (click)="
              action.command?.({
                originalEvent: $event,
                item: action,
                index: $index,
              })
            "
      ></button>
      } }

      <button
        pButton
        class="p-button-sm p-button-text order-3 md:order-none"
        icon="pi pi-sliders-v"
        [pTooltip]="'Nastavenia zobrazenia'"
        [tooltipOptions]="{ showDelay: 300 }"
        (click)="viewMenu.toggle($event)"
      ></button>
    </div>
  </div>
</div>

<p-menu
  #viewMenu
  [model]="viewActions()"
  [popup]="true"
  [appendTo]="'body'"
></p-menu>

<p-menu
  #actionsMenu
  [model]="config.header?.actions ?? []"
  [popup]="true"
  [appendTo]="'body'"
></p-menu>

@if (!isMobile()) {
<p-splitter
  #splitter
  [layout]="'horizontal'"
  [minSizes]="[10, 60]"
  [panelSizes]="[20, 80]"
  [stateKey]="splitterStateKey"
  stateStorage="local"
  (onResizeEnd)="splitterResizeEnd($event)"
  styleClass="h-full"
>
  <ng-template pTemplate>
    <ng-container *ngTemplateOutlet="unscheduledTasks"></ng-container>
  </ng-template>
  <ng-template pTemplate>
    <ng-container *ngTemplateOutlet="calendarTemplate"></ng-container>
  </ng-template>
</p-splitter>
} @else {
<div class="flex flex-col min-h-screen w-full">
  @if (unscheduledVisible()) {
  <ng-container *ngTemplateOutlet="unscheduledTasks"></ng-container>
  }
  <ng-container *ngTemplateOutlet="calendarTemplate"></ng-container>
</div>
}

<ng-template
  #defaultEventTpl
  konCalendarEvent="event"
  let-event
  let-view="view"
  let-data="data"
>
  @if (!event.extendedProps?.['disabled']) {
  <div
    [routerLink]="getDefaultAction(event.extendedProps?.['entity'])?.routerLink"
    (click)="getDefaultAction(event.extendedProps?.['entity'])?.command"
    (contextmenu)="
      onContextMenuSelectionChange($event, event.extendedProps?.['entity'])
    "
    class="w-full h-full overflow-hidden flex flex-col px-1 relative"
    [pTooltip]="event.title"
  >
    <ng-container
      *ngTemplateOutlet="
        getEventTemplate('title') ?? defaultTitleTpl;
        context: getTemplateContext(event, view, data)
      "
    />
    <ng-container
      *ngTemplateOutlet="
        getEventTemplate('content') ?? null;
        context: getTemplateContext(event, view, data)
      "
    />
  </div>
  } @else {
  <div
    class="w-full h-full overflow-hidden flex flex-col px-1 relative"
    [pTooltip]="event.title"
  ></div>
  }
</ng-template>

<ng-template #defaultTitleTpl let-event>
  <div
    class="overflow-hidden whitespace-nowrap overflow-ellipsis min-h-fit grid"
  >
    {{ getStartTime(event) }}
    <span class="font-medium">{{ event.title ?? '--' }}</span>
  </div>
</ng-template>

<ng-template #unscheduledTasks>
  <div
    class="w-full md:p-7 md:pr-3.5 bg-[var(--p-content-background)] rounded-t-2xl overflow-auto max-h-full flex flex-col"
    #unscheduledEventsContainer
  >
    <div class="flex items-center gap-x-2 max-sm:p-3.5 max-sm:pb-0 pb-5">
      <kon-search
        class="grow"
        [text]="searchText()"
        (searchChange)="onSearchChange($event)"
      />
      <p-button
        size="small"
        text="true"
        rounded="true"
        [icon]="filterUnscheduled() ? 'pi pi-filter-slash' : 'pi pi-filter'"
        [pTooltip]="
          filterUnscheduled()
            ? 'Zrušiť filtrovanie podľa vybraných kalendárov'
            : 'Filtrovať podľa vybraných kalendárov'
        "
        (click)="toggleFilterUnscheduled()"
      ></p-button>
    </div>
    <ng-container>
      <p-tabView class="sm:hidden h-full">
        <ng-container *ngFor="let group of unscheduledGrouped(); let i = index">
          <p-tabPanel [header]="group.key ? group.key : '--'">
            <div
              class="px-2 flex flex-row flex-nowrap overflow-auto sm:block gap-2"
            >
              <ng-container *ngFor="let event of group.events">
                <kon-resource-calendar-unscheduled-card [event]="event">
                  <ng-container
                    *ngTemplateOutlet="
                      getEventTemplate('event') ?? defaultEventTpl;
                      context: getTemplateContext(event, null, null)
                    "
                  />
                </kon-resource-calendar-unscheduled-card>
              </ng-container>
            </div>
          </p-tabPanel>
        </ng-container>
      </p-tabView>
      @if (!unscheduledGrouped().length) {
      <span class="text-center block w-full pt-1 pb-2 sm:hidden border-b-2">
        {{
          stateSignal()?.searchUnscheduled
            ? 'Nenašli sa žiadne úlohy'
            : 'Žiadne nenaplánované úlohy'
        }}
      </span>
      }
    </ng-container>
    <ng-container>
      @if (unscheduledGrouped(); as groups) {
      <p-accordion
        [multiple]="true"
        class="w-full max-h-full overflow-auto hidden sm:flex sm:flex-col sm:flex-1 rounded-none pb-3.5"
      >
        <ng-container *ngFor="let group of groups">
          <p-accordionTab [header]="group.key ? group.key : '--'">
            <ng-container *ngFor="let event of group.events">
              <kon-resource-calendar-unscheduled-card [event]="event">
                <ng-container
                  class="p-0"
                  *ngTemplateOutlet="
                    getEventTemplate('event') ?? defaultEventTpl;
                    context: getTemplateContext(event, null, null)
                  "
                />
              </kon-resource-calendar-unscheduled-card>
            </ng-container>
          </p-accordionTab>
        </ng-container>
        <ng-container *ngIf="!groups.length">
          <span class="text-center block px-2 w-full mt-4">
            {{
              stateSignal()?.searchUnscheduled
                ? 'Nenašli sa žiadne úlohy'
                : 'Žiadne nenaplánované úlohy'
            }}
          </span>
        </ng-container>
      </p-accordion>
      }
    </ng-container>
  </div>
</ng-template>
<ng-template #calendarTemplate>
  <div class="md:p-7 md:pl-3.5 flex flex-col flex-1 w-full h-full">
    <full-calendar
      #calendar
      [options]="calendarOptions()"
      [ngClass]="{ 'max-sm:rounded-t-2xl': !unscheduledVisible() }"
      class="flex flex-1 w-full h-full md:border sm:rounded-r-2xl md:rounded-2xl bg-[var(--p-content-background)] max-sm:rounded-b-2xl"
    >
      <ng-template #eventContent let-event>
        <ng-container
          *ngTemplateOutlet="
            getEventTemplate(event) ?? defaultEventTpl;
            context: getTemplateContext(event.event, event.view, event)
          "
        />
      </ng-template>
    </full-calendar>
  </div>
</ng-template>
